import { useEffect, useState } from 'react';
import { formatIQD } from '../../../shared/format.js';
import { calculateBillClient } from '../../../shared/pricingClient.js';

export function LiveBillBadge({ session }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 5000);
    return () => clearInterval(id);
  }, []);

  // المشترك شهرياً: لا رسوم لعب ولا تسعير زمني إطلاقاً. الحساب المحلي كان
  // سيعرض له مبلغاً ساعياً متزايداً بينما الخادم يرسل صفراً — فلا يُشغَّل عليه.
  if (session.subscriptionCovered) {
    return <span className="font-bold text-[#0E7490]">مشمول بالاشتراك</span>;
  }

  // view-only estimate; backend is authoritative
  const { total } = calculateBillClient({
    startTime: session.startTime,
    pricingType: session.pricingType,
    hourlyRateSnapshot: session.hourlyRateSnapshot,
    graceMinutesSnapshot: session.graceMinutesSnapshot,
    roundingSnapshot: session.roundingSnapshot,
    minimumChargeSnapshot: session.minimumChargeSnapshot,
    packageSnapshot: session.packageSnapshot || session.package,
    fixedAmount: session.entryAmount,
    openAmount: session.entryAmount
  });
  // suppress unused tick warning
  void tick;

  return <span className="font-bold text-orange-deep">{formatIQD(total)}</span>;
}
